import { useMemo } from 'react';
import { Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  HAS_REAL_BOT,
  buildAttributedBotLink,
  isTelegramMiniApp,
} from '../ton/referral';

/**
 * Floating "Open in Telegram" pill shown to browser visitors of the plain web
 * deployment (mobile and desktop) — never inside the Telegram Mini App
 * (Telegram is where they already are).
 */
export function OpenInTelegram() {
  const { t } = useTranslation();
  const show = useMemo(() => HAS_REAL_BOT && !isTelegramMiniApp(), []);
  if (!show) return null;
  return (
    <a className="open-in-tg" href={buildAttributedBotLink()}>
      <span className="open-in-tg__badge">
        <Send size={13} strokeWidth={2.2} aria-hidden="true" />
        Telegram
      </span>
      <span className="open-in-tg__label">{t('openInTelegram')}</span>
    </a>
  );
}
